const typographyModalEquipServQuest = {
  true: 'Nova',
  false: 'Editar',
  text: 'Pergunta',
  profileError: 'Aguarde o arquivo subir'
};

export default typographyModalEquipServQuest;
